<template>
  <div
    class="position-relative default-slider"
  >
    <!-- <span v-show="showPrev" >
      <slot name="prev" />
    </span> -->

    <div v-if="arrows" class="customNav position-absolute">
      <div class="grid-container">
        <div class="grid-x">
          <div class="cell small-6">
            <button class="arrows prev float-left" :id="prevHandler" >
              <svg
                width="18"
                height="26"
                viewBox="0 0 18 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17 1L1 13L17 25" stroke="#232323"></path>
              </svg>
            </button>
          </div>
          <div class="cell small-6">
            <button class="arrows next float-right" :id="nextHandler">
              <svg
                width="18"
                height="26"
                viewBox="0 0 18 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 1L17 13L1 25" stroke="#232323"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div :id="elementHandle" :class="['owl-carousel', 'owl-theme']">
      <slot />
    </div>
    <!-- <span v-show="showNext" >
      <slot name="next" />
    </span> -->
  </div>
</template>
<script>
import "owl.carousel";

const events = [
  "initialize",
  "initialized",
  "resize",
  "resized",
  "refresh",
  "refreshed",
  "update",
  "updated",
  "drag",
  "dragged",
  "translate",
  "translated",
  "to",
  "changed",
];

export default {
  name: "VOwlCarousel",
  props: {
    //Is main Container
    isMain: {
      type: Boolean,
      default: false,
    },
    arrows: {
      type: Boolean,
      default: false,
    },

    items: {
      type: Number,
      default: 3,
    },
    margin: {
      type: Number,
      default: 0,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
    mouseDrag: {
      type: Boolean,
      default: true,
    },
    touchDrag: {
      type: Boolean,
      default: true,
    },
    pullDrag: {
      type: Boolean,
      default: true,
    },
    freeDrag: {
      type: Boolean,
      default: false,
    },
    stagePadding: {
      type: Number,
      default: 0,
    },
    merge: {
      type: Boolean,
      default: false,
    },
    mergeFit: {
      type: Boolean,
      default: false,
    },
    autoWidth: {
      type: Boolean,
      default: false,
    },
    startPosition: {
      type: Number,
      default: 0,
    },
    uRLhashListener: {
      type: Boolean,
      default: false,
    },
    nav: {
      type: Boolean,
      default: true,
    },
    rewind: {
      type: Boolean,
      default: true,
    },
    navText: {
      type: Array,
      default: () => ["next", "prev"],
    },
    navElement: {
      type: String,
      default: "div",
    },
    slideBy: {
      type: [Number, String],
      default: 1,
    },
    slideTransition: {
      type: String,
      default: "",
    },
    dots: {
      type: Boolean,
      default: true,
    },
    dotsEach: {
      type: [Number, Boolean],
      default: false,
    },
    dotsData: {
      type: Boolean,
      default: false,
    },
    lazyLoad: {
      type: Boolean,
      default: false,
    },
    lazyLoadEager: {
      type: Number,
      default: 0,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    autoplaySpeed: {
      type: Boolean,
      default: false,
    },
    autoplayTimeout: {
      type: Number,
      default: 5000,
    },
    autoplayHoverPause: {
      type: Boolean,
      default: false,
    },
    smartSpeed: {
      type: Number,
      default: 250,
    },
    fluidSpeed: {
      type: [Number, Boolean],
      default: false,
    },
    navSpeed: {
      type: [Number, Boolean],
      default: false,
    },
    dragEndSpeed: {
      type: [Number, Boolean],
      default: false,
    },
    callbacks: {
      type: Boolean,
      default: true,
    },
    responsive: {
      type: Object,
      default: () => {},
    },
    responsiveRefreshRate: {
      type: Number,
      default: 200,
    },
    responsiveBaseElement: {
      type: String,
      default: "window",
    },
    video: {
      type: Boolean,
      default: false,
    },
    videoHeight: {
      type: [Number, Boolean],
      default: false,
    },
    videoWidth: {
      type: [Number, Boolean],
      default: false,
    },
    animateOut: {
      type: [String, Boolean],
      default: false,
    },
    animateIn: {
      type: [String, Boolean],
      default: false,
    },
    fallbackEasing: {
      type: String,
      default: "swing",
    },
    info: {
      type: Function,
      default: () => {},
    },
    itemElement: {
      type: String,
      default: "div",
    },
    stageElement: {
      type: String,
      default: "div",
    },
    navContainer: {
      type: [String, Boolean],
      default: false,
    },
    dotsContainer: {
      type: [String, Boolean],
      default: false,
    },
    checkVisible: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {
      showPrev: false,
      showNext: true,

      prevHandler: "carousel_prev_" + this.generateUniqueId(),
      elementHandle: "carousel_" + this.generateUniqueId(),
      nextHandler: "carousel_next_" + this.generateUniqueId(),
    };
  },

  mounted: function() {
    var self = this;
    const owl = $("#" + this.elementHandle);

    owl.on('initialize.owl.carousel', function(event) {
      self.$emit('initialize', event);
    });
    owl.on('initialized.owl.carousel', function(event) {
      self.$emit('initialized', event);
    });

    owl.owlCarousel({
      items: this.items,
      margin: this.margin,
      loop: this.loop,
      center: this.center,
      mouseDrag: this.mouseDrag,
      touchDrag: this.touchDrag,
      pullDrag: this.pullDrag,
      freeDrag: this.freeDrag,
      stagePadding: this.stagePadding,
      merge: this.merge,
      mergeFit: this.mergeFit,
      autoWidth: this.autoWidth,
      startPosition: this.startPosition,
      uRLhashListener: this.uRLhashListener,
      nav: this.nav,
      rewind: this.rewind,
      navText: this.navText,
      navElement: this.navElement,
      slideBy: this.slideBy,
      slideTransition: this.slideTransition,
      dots: this.dots,
      dotsEach: this.dotsEach,
      dotsData: this.dotsData,
      lazyLoad: this.lazyLoad,
      lazyLoadEager: this.lazyLoadEager,
      autoplay: this.autoplay,
      autoplaySpeed: this.autoplaySpeed,
      autoplayTimeout: this.autoplayTimeout,
      autoplayHoverPause: this.autoplayHoverPause,
      smartSpeed: this.smartSpeed,
      fluidSpeed: this.fluidSpeed,
      navSpeed: this.navSpeed,
      dragEndSpeed: this.dragEndSpeed,
      callbacks: this.callbacks,
      responsive: this.responsive,
      responsiveRefreshRate: this.responsiveRefreshRate,
      responsiveBaseElement: this.responsiveBaseElement,
      video: this.video,
      videoHeight: this.videoHeight,
      videoWidth: this.videoWidth,
      animateOut: this.animateOut,
      animateIn: this.animateIn,
      fallbackEasing: this.fallbackEasing,
      info: this.info,
      itemElement: this.itemElement,
      stageElement: this.stageElement,
      navContainer: this.navContainer,
      dotsContainer: this.dotsContainer,
      checkVisible: this.checkVisible,
    });

    $("#" + this.prevHandler).click(function() {
      owl.trigger("prev.owl.carousel");
    });

    $("#" + this.nextHandler).click(function() {
      owl.trigger("next.owl.carousel");
    });

    events.forEach((eventName) => {
      owl.on(`${eventName}.owl.carousel`, (event) => {
        this.$emit(eventName, event);
      });
    });

    if (!this.loop) {
      owl.on("changed.owl.carousel", (event) => {
        // start
        if (event.item.index === 0) {
          this.showPrev = false;
          this.showNext = true;
        } else {
          const currnetel = Math.floor(event.item.index + event.page.size);
          // last
          if (currnetel === event.item.count) {
            this.showPrev = true;
            this.showNext = false;
          } else {
            this.showPrev = true;
            this.showNext = true;
          }
        }
      });
    }
  },

  methods: {
    generateUniqueId() {
      return Math.random()
        .toString(36)
        .substring(2, 15);
    },
  },
};
</script>

<style lang="scss" scoped>
.customNav {
  width: 100%;
  z-index: 2;
  //position: relative;
}
.arrows {
  width: 48px;
  height: 48px;
  // border-color: #000;
  // position: absolute;
  // top: 50%;
  // transform:translateY(45%);
  margin-top: -31px;
  cursor: pointer;

  path{
    stroke: white;
    text-shadow: 0 0 25px rgba(0, 0, 0, 0.5);
    opacity: 0.6;
  }
}
.prev {
  // border-bottom: 2px solid;
  // border-left: 2px solid;
  // transform: rotate(45deg);
  left: 10px;
}

.next {
  // border-bottom: 2px solid;
  // border-left: 2px solid;
  // transform: rotate(-135deg);
  right: 10px;
}

.default-slider {
  .customNav {
    top: 48%;
  }
}
</style>
